export default "__VITE_ASSET__BPwUPZwb__"